export const range = (n: number): number[] =>
    Array.from((new Array(n)).keys()).map((_, i) => i);

export const add = (a: number) => (b: number) => a + b;
export const subtract = (a: number) => (b: number) => b - a;
export const lessThan = (a: number) => (b: number) => b < a;
export const greaterThan = (a: number) => (b: number) => b > a;
export const lessThanOrEqual = (a: number) => (b: number) => b <= a;
export const greaterThanOrEqual = (a: number) => (b: number) => b >= a;
export const round = (n: number, p = 2) => {
    const f = Math.pow(10, p);
    return Math.round(n * f) / f;
};
